import globals from "@lvt/globals";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


export interface SpeakerTalkdownStart {
    token: string;
    lvt_live_unit_id: string;
}

interface ApiResponse<T> {
    status: number;
    status_message: string;
    data: T;
}


export const speakerTalkdownApi = createApi({
    reducerPath: "speaker-talkdown",
    baseQuery: fetchBaseQuery({
        baseUrl: globals.userdashboard.proxyUrl,
        credentials: "include",
    }),
    endpoints: (builder) => ({
        speakerTalkdownStart:builder.query<ApiResponse<SpeakerTalkdownStart>, number>({
            query: (liveUnitId) => {
                return `/api/speaker_talkdown/start/${liveUnitId}`;
            },
        }),
        speakerTalkdownHeartbeat: builder.query<ApiResponse<undefined>, [number, string]> ({
            query: ([liveUnitId, token]) => {
                return `/api/speaker_talkdown/heartbeat/${liveUnitId}/${token}`;
            },
        }),
        speakerTalkdownEnd: builder.query<ApiResponse<undefined>, [number, string]> ({
            query: ([liveUnitId, token]) => {
                return `/api/speaker_talkdown/end/${liveUnitId}/${token}`;
            },
        }),
    }),
});

export const { useLazySpeakerTalkdownStartQuery, useLazySpeakerTalkdownHeartbeatQuery, useLazySpeakerTalkdownEndQuery } = speakerTalkdownApi;
